import { useAuthenticator } from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

export default function Layout() {
  const { route } = useAuthenticator((ctx) => [ctx.route]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  // Redirige si no está autenticado
  useEffect(() => {
    if (route === "authenticated") {
      setIsLoading(false);
    } else {
      navigate("/login");
    }
  }, [route, navigate]);

  // Muestra loading mientras se verifica autenticación
  if (isLoading) {
    return (
      <div style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0f1117",
        color: "#e2e8f0",
        fontFamily: "'DM Sans', sans-serif"
      }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ 
            fontSize: "32px", 
            marginBottom: "16px",
            animation: "spin 1s linear infinite"
          }}>⟳</div>
          <div>Cargando...</div>
        </div>
        <style>{`
          @keyframes spin { to { transform: rotate(360deg) } }
        `}</style>
      </div>
    );
  }

  return <Outlet />;
}
